import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

// Tenant
const TenantListPage = lazyWithReload(() => import('src/pages/tenants/list'));
const TenantDetailsPage = lazyWithReload(() => import('src/pages/tenants/details'));
const BillingDetail = lazyWithReload(() => import('src/pages/setting/invoice-detail'));
const TenantUserDetailsPage = lazyWithReload(() => import('src/pages/tenants/tenant-user-details'));
// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const tenantRoutes: RouteObject[] = [
  {
    path: 'tenant',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      { index: true, element: <TenantListPage /> },
      { path: 'list', element: <TenantListPage /> },
      { path: ':id/details', element: <TenantDetailsPage /> },
      { path: ':tenantId/details/invoice/:id/details', element: <BillingDetail /> },
      { path: ':tenantId/details/user/:userId/details', element: <TenantUserDetailsPage /> }
    ],
  },
];
